import AbstractValidator from './AbstractValidator';

export default class NotInArray extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        inArray: 'Ihre Eingabe ist kein gültiger Eingabewert.',
    };

    run()
    {
        let haystack  = this._options.haystack || [];

        if (!this.checkNotInArray(haystack))
        {
            this.error = this.getMessage('inArray');
        }
    }

    checkNotInArray(array: any[]): boolean
    {
        for (let item of array)
        {
            if (Array.isArray(item))
            {
                if(!this.recursive)
                {
                    continue;
                }

                return this.checkNotInArray(item);
            }
            else if (this.strict && item === this.value)
            {
                return false;
            }
            else if (!this.strict && item == this.value)
            {
                return false;
            }
        }

        return true;
    }

    get recursive()
    {
        return !!this._options.recursive;
    }

    get strict()
    {
        return !!this._options.strict;
    }
}